import { render } from "./Home.vue?vue&type=template&id=9e2aca24&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=9e2aca24&lang=less&scoped=true"

import exportComponent from "C:\\project\\结构计算网\\famous-build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e2aca24"]])

export default __exports__